import { Button, Col, Empty, message, Modal, Radio, Row, Select } from 'antd';
import { OptionProps } from 'antd/lib/select';
import { gql } from 'apollo-boost';
import React, { Component } from 'react';
import { Mutation, Query } from 'react-apollo';

import { DateRange } from '../../types/base';
import { EnrollmentGroup } from '../../types/enrollment';
import { MarketingActivity } from '../../types/marketingActivity';
import { Enrollment, Sku } from '../enrollment/Enrollment';
import { ADMISSION_QUIZ, skusListQuery, transferEnrollmentToAnotherSkuMutation } from './UserDetail';
import { ALL_USERS_QUERY } from './Users';

const groupListQuery = gql`
  query getGroupListQuery($skuIds: [ID], $teacherIds: [ID], $name: String) {
    enrollmentGroups(skuIds: $skuIds, teacherIds: $teacherIds, name: $name) {
      id
      name
      createdAt
      sku {
        id
        name
        start
        end
      }
      size
      teacher {
        id
        name
      }
      enrollments {
        id
      }
    }
  }
`;
interface Props {
  enrollment: Enrollment;
  userId: number;
  transferNeedData: {
    marketingActivityFilterOptions: MarketingActivity[];
    selectedMarketingActivityFilter: number;
    clockInDateRange: DateRange;
  };
}
interface GroupListData {
  enrollmentGroups: EnrollmentGroup[];
}
interface State {
  skuId?: number;
  groupId?: number;
  variables: {
    ids?: number[];
  };
  isTransferWithDifferDatePopupConfirmVisible: boolean;
  isSameTeacher: boolean;
  isSameTeacherInd: number;
  isGroupFull: boolean;
}

export class TransferSkuToAnother extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      variables: {},
      isTransferWithDifferDatePopupConfirmVisible: false,
      isSameTeacher: false,
      isSameTeacherInd: 0,
      isGroupFull: false,
    };
    this.cancelTransferSkuOperation = this.cancelTransferSkuOperation.bind(this);
    this.onTransferEnrollmentToAnotherSkuInDifferentDate = this.onTransferEnrollmentToAnotherSkuInDifferentDate.bind(
      this,
    );
  }

  cancelTransferSkuOperation() {
    this.setState({
      isTransferWithDifferDatePopupConfirmVisible: false,
      skuId: undefined,
    });
  }

  onTransferEnrollmentToAnotherSkuInDifferentDate() {
    this.setState({ isTransferWithDifferDatePopupConfirmVisible: true });
  }

  isGroupFull(enrollmentGroups: EnrollmentGroup[], groupId: number | undefined) {
    const enrollmentGroup = enrollmentGroups.find(item => item.id === String(groupId));
    if (!groupId || (enrollmentGroup && enrollmentGroup.size > enrollmentGroup.enrollments.length)) return false;
    return true;
  }

  selectGroup() {
    const { isSameTeacher, groupId } = this.state;
    let teacherIds: number | undefined;
    if (isSameTeacher) {
      teacherIds = this.props.enrollment.group.teacher.id;
    }
    return (
      <Query<GroupListData> query={groupListQuery} variables={{ teacherIds, skuIds: this.state.skuId }}>
        {({ loading, error, data }) => {
          if (error) return <div>{error.message}</div>;
          if (!data) {
            // @ts-ignore
            return <Empty />;
          }
          const { enrollmentGroups = [] } = data || {};
          return (
            <Select
              style={{ width: '100%', marginTop: 8 }}
              allowClear
              placeholder="选择班级"
              value={groupId}
              onChange={(value: number) => {
                const isGroupFull = this.isGroupFull(enrollmentGroups, value);
                this.setState({
                  isGroupFull,
                  groupId: value,
                });
              }}
            >
              {enrollmentGroups.map(group => {
                return (
                  <Select.Option value={group.id} key={group.id}>
                    {group.name}
                  </Select.Option>
                );
              })}
            </Select>
          );
        }}
      </Query>
    );
  }

  render() {
    const { enrollment, userId } = this.props;
    const skuGroupIds = enrollment.sku.groups.map(v => v.id);
    const {
      marketingActivityFilterOptions,
      selectedMarketingActivityFilter,
      clockInDateRange,
    } = this.props.transferNeedData;
    const activityId = marketingActivityFilterOptions[selectedMarketingActivityFilter].id;
    return (
      <>
        <Button
          style={{ marginLeft: 8 }}
          type="primary"
          icon="plus"
          onClick={this.onTransferEnrollmentToAnotherSkuInDifferentDate}
        >
          调期
        </Button>
        <Mutation
          mutation={transferEnrollmentToAnotherSkuMutation}
          variables={{
            id: enrollment.id,
            skuId: this.state.skuId,
            sameTeacher: this.state.isSameTeacher,
            groupId: this.state.groupId,
          }}
          refetchQueries={[
            {
              query: ALL_USERS_QUERY,
              variables: {
                activityId,
                ids: [userId],
                dateRange: clockInDateRange,
                miniGameName: ADMISSION_QUIZ,
              },
            },
          ]}
        >
          {(transferEnrollmentToAnotherSku, { loading }) => {
            return (
              <Row gutter={24}>
                <Col xs={24} md={24} lg={12} xl={12} xxl={12}>
                  <Modal
                    visible={this.state.isTransferWithDifferDatePopupConfirmVisible}
                    onOk={async () => {
                      if (!this.state.skuId) {
                        message.error('请选择要调期的sku！');
                        return;
                      }

                      if (loading) {
                        return;
                      }
                      try {
                        await transferEnrollmentToAnotherSku();
                        message.success('延期成功');
                        this.setState({ isTransferWithDifferDatePopupConfirmVisible: false });
                      } catch (e) {
                        message.error('延期失败！');
                      }
                    }}
                    onCancel={this.cancelTransferSkuOperation}
                  >
                    <Modal
                      title="该班级已满员，是否坚持调整?"
                      visible={this.state.isGroupFull}
                      onOk={() => {
                        this.setState({ isGroupFull: false });
                      }}
                      onCancel={() => {
                        this.setState({ isGroupFull: false, groupId: undefined });
                      }}
                    />
                    <Row gutter={24}>
                      <Col span={23}>
                        <Query query={skusListQuery} variables={{ skuGroupIds }}>
                          {({ loading, error, data }) => {
                            if (error) return <div>{error.message}</div>;
                            if (loading) return <div>loading...</div>;
                            if (!data) {
                              // @ts-ignore
                              return <Empty />;
                            }
                            const skus = data.skus;
                            const currentSku = this.props.enrollment.sku;
                            const selectSkus = skus.filter((item: Sku) => item.id !== currentSku.id);
                            return (
                              <div>
                                <Select
                                  style={{ width: '100%' }}
                                  showSearch
                                  value={this.state.skuId}
                                  placeholder="选择/输入sku"
                                  onChange={(value: number) => {
                                    this.setState({
                                      skuId: value,
                                    });
                                  }}
                                  optionFilterProp="children"
                                  filterOption={(input: string, option: React.ReactElement<OptionProps>) => {
                                    return String(option.props.children).indexOf(input) >= 0;
                                  }}
                                >
                                  {selectSkus.map((sku: Sku) => {
                                    return (
                                      <Select.Option value={sku.id} key={sku.id}>
                                        {sku.name}
                                      </Select.Option>
                                    );
                                  })}
                                </Select>
                                <div style={{ marginTop: 8 }}>
                                  <Radio.Group
                                    onChange={e => {
                                      e.target.value === 0
                                        ? this.setState({ isSameTeacher: false })
                                        : this.setState({ isSameTeacher: true });
                                      this.setState({ isSameTeacherInd: e.target.value });
                                    }}
                                    value={this.state.isSameTeacherInd}
                                  >
                                    <Radio value={0}>分配不同的老师</Radio>
                                    <Radio value={1}>分配同一个老师</Radio>
                                  </Radio.Group>
                                </div>

                                {!!this.state.skuId && this.selectGroup()}
                              </div>
                            );
                          }}
                        </Query>
                      </Col>
                    </Row>
                  </Modal>
                </Col>
              </Row>
            );
          }}
        </Mutation>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/user/TransferSku.tsx